export default function () {
    const trackerName = window.ga && window.ga.getAll && window.ga.getAll()[0]
        ? window.ga.getAll()[0].get('name')
        : '';
    return `${trackerName}.send`;
}
